<template>
  <div class="login">
    <div class="connect-form">
      <div class="head-form">
        <div class="icon-head"></div>
        <div class="dazzl-title">DGSCGC</div>
        <div class="dazzl-desc">Credilog</div>
      </div>
      <hr class="separator">
      <div class="wrapper-input">
        <div class="wrapper-title">
          Veuillez vous connecter
        </div>
        <input class="login-input email" name="email" placeholder="Identifiant" type="text" v-model="email" @keypress.enter.stop="tryLogin()">
        <input class="login-input password" name="password" placeholder="Mot de passe" type="password" v-model="password" @keypress.enter.stop="tryLogin()">
        <div class="login-submit btn-c" @click="tryLogin()">Se connecter</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent, Action } from '@/libs/BaseComponent'

@Component({
})
export default class Home extends BaseComponent {
  email = ''
  password = ''
  firstname = ''
  lastname = ''
  step = 'login'

  @Action('entities/users/login') login () {}
  @Action('entities/users/signup') signup () {}

  async tryLogin () {
    const result = await this.login({ email: this.email, password: this.password })
    if (result && result.error) {
      this.$notify({
        type: 'error',
        title: 'Signin error',
        message: result.error
      })
    }
  }
  async trySignup () {
    const result = await this.signup({ email: this.email, password: this.password, name: this.firstname, lastname: this.lastname })
    if (result && result.success) {
      this.step = 'login'
    } else if (result && result.error) {
      this.$notify({
        type: 'error',
        title: 'Signup error',
        message: result.error
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .connect-form {
      width: 460px;
      display: flex;
      flex-direction: column;
      background: #da140a;
      border-radius: 8px;
      border: 1px solid #ffbb4f;
      padding: 10px;

      .separator {
        width: 100%;
        border-top: 0.5px solid rgba(255,255,255,0.6);
      }
      .head-form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .dazzl-title {
          font-size:26px;
          color: #fff;
        }
        .dazzl-desc {
          font-size: 20px;
          color: rgba(255,255,255,0.6);
        }
      }

      .wrapper-input {
        padding: 10px 20px 30px 20px;
        color: #fff;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
          padding-top:15px;
          text-align:center;
          font-size: 15px;
          margin:0;
          text-decoration: underline;
          color: rgba(255,255,255,0.8);
          cursor: pointer;
          transition:0.25s;

          &:hover {
            color: rgba(255,255,255,1);
          }
        }
        .wrapper-title {
          font-size: 16px;
          padding-bottom: 15px;
          text-align: center;
        }

        .login-input {
          width: calc(100% - 80px);
          padding: 12px;
          font-size: 14px;
          margin: 0 40px 20px 40px;
          border-radius: 8px;
          border: 1px solid rgba(200,200,200,0.6);
          background: rgba(0,0,0,0.6);
          color: rgba(255,255,255,0.6);
          transition: 0.25s;

            &:active, &:focus {
              color: #fff;
              border: 1px solid rgba(255,255,255,1);
            }
        }
        .login-submit {
          width: calc(100% - 80px);
          padding: 16px;
          text-align:center;
          margin: 0 40px 20px 40px;
          background: #fdd318;
          border-radius: 8px;
          border: 1px solid #da140a;
          cursor: pointer;
          transition: 0.25s;
          color: #333;

          &:hover {
            border: 1px solid rgba(200,200,200,1);
          }
        }
      }
    }
  }
</style>
